import React from 'react'
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function LHSection() {
  return (
    <div>
      <div className="relative bg-black/40 w-full overflow-x-hidden">
  {/* Background Video Section */}
  <video
    className="absolute inset-0 w-full h-full object-cover"
    autoPlay
    loop
    muted
    playsInline
  >
    <source src="/assets/videos/investor-rise-bg-map.mp4" type="video/mp4" />
  </video>
  <div className="absolute inset-0 bg-black bg-opacity-30" />
  <div className="w-full">
    <div className="flex flex-col md:flex-row items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
      
      {/* Text Section */}
      <motion.div
        initial={{ x: '100%' }}
        whileInView={{ x: '0%' }}
        transition={{ duration: 1.2, ease: 'easeInOut' }}
        viewport={{ once: true }}
        className="md:w-1/2 relative"
      >
        <div className="overflow-hidden">
          <motion.div
            initial={{ clipPath: 'inset(0 100% 0 0)' }}
            whileInView={{ clipPath: 'inset(0 0% 0 0)' }}
            transition={{ duration: 1.2, ease: "easeInOut", delay: 1 }}
            viewport={{ once: true }}
            className="bg-white/90 p-8 rounded-lg shadow-lg"
          >
            <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-slate-900">
              Using The Force to Empower Our Communities
            </h2>
            <p className="text-black text-base sm:text-lg leading-relaxed">
              InvetorRise is committed to bettering the communities in which we work and play. Making a difference is part of our DNA. We believe we are only as strong as the communities we serve.
            </p>
            <Link to="/contact">
            <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold  bg-teal-500 shadow-xl text-lg group">
              <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-tslate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
              <span className="relative z-10">Contact Us</span>
            </button>
            </Link>
          </motion.div>
        </div>
      </motion.div>

      {/* Image Section */}
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
        className="md:w-1/2 relative group"
      >
        {/* Wrapper to contain animated frames and prevent overflow */}
        <div className="relative">
  {/* Frames go outside the image */}
  {/* Top-left animated frame */}
  <motion.div
    animate={{ y: [0, -18, 2, 0] }}
    transition={{ repeat: Infinity, duration: 3 }}
    className="absolute top-0 left-0 -translate-x-4 -translate-y-4 w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-teal-500 z-10"
  />
  {/* Bottom-right animated frame */}
  <motion.div
    animate={{ y: [0, 18, -2, 0] }}
    transition={{ repeat: Infinity, duration: 3 }}
    className="absolute bottom-0 right-0 translate-x-4 translate-y-4 w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-teal-500 z-10"
  />

  {/* Image container */}
  <div className="relative overflow-hidden shadow-2xl">
    <img
      src="/assets/images/our-process-contact-img.png"
      alt="What We Do"
      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
    />
    {/* Overlay */}
    <div className="absolute inset-0 bg-teal-500 bg-opacity-25 pointer-events-none" />
  </div>
</div>

      </motion.div>
    </div>
  </div>
</div>
    </div>
  )
}

export default LHSection
